module.exports = __webpack_public_path__ + "static/media/tax_integration.54b8312f.svg";